<template>
  <v-container class="container-card">
    <FiltroRelatorios @selectedFilters="filters = $event" />
    <Relatorios :filters="filters" :list="menus" />
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import FiltroRelatorios from "@/components/comissao/relatorios/FiltroRelatorios";
import Relatorios from "@/components/comissao/relatorios/Relatorios";
export default {
  components: {
    FiltroRelatorios,
    Relatorios
  },

  data() {
    return {
      filters: {},
      menus: [
        {
          title: "Relatórios",
          icon: "mdi-file-outline",
          reportList: [
            {
              text: "Relatório Colaboradores",
              service: "colaborador",
              permission: 1029
            }
          ]
        }
      ]
    };
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Relatórios Colaborador");
  }
};
</script>

<style></style>
